export const LANGUAGE_OPTIONS = [
  { label: 'Afrikaans', value: 'af' },
  { label: 'Bɛ', value: 'ak' },
  { label: 'shqiptare', value: 'sq' },
  { label: 'አማርኛ', value: 'am' },
  { label: 'عربي', value: 'ar' },
  { label: 'հայերեն', value: 'hy' },
  { label: 'অসমীয়া', value: 'as' },
  { label: 'Aymara', value: 'ay' },
  { label: 'Azərbaycan', value: 'az' },
  { label: "U b'a don", value: 'bm' },
  { label: 'euskara', value: 'eu' },
  { label: 'беларускі', value: 'be' },
  { label: 'বাংলা', value: 'bn' },
  { label: 'bosanski', value: 'bs' },
  { label: 'български', value: 'bg' },
  { label: 'မြန်မာ', value: 'my' },
  { label: 'català, valencià', value: 'ca' },
  { label: 'Chichewa, Chewa, Nyanja', value: 'ny' },
  { label: '中国人', value: 'zh' },
  { label: 'Corsu', value: 'co' },
  { label: 'Hrvatski', value: 'hr' },
  { label: 'čeština', value: 'cs' },
  { label: 'dansk', value: 'da' },
  { label: 'ދިވެހި، ދިވެހި، މޯލްޑިވިއަން', value: 'dv' },
  { label: 'Nederlands, Vlaams', value: 'nl' },
  { label: 'English', value: 'en' },
  { label: 'Esperanto', value: 'eo' },
  { label: 'eesti keel', value: 'et' },
  { label: 'Aŋgba', value: 'ee' },
  { label: 'Suomalainen', value: 'fi' },
  { label: 'Français', value: 'fr' },
  { label: 'Westerfrysk', value: 'fy' },
  { label: 'Gàidhlig, Scottish Gaelic', value: 'gd' },
  { label: 'galego', value: 'gl' },
  { label: 'Obulungi', value: 'lg' },
  { label: 'ქართული', value: 'ka' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Ελληνικά, Σύγχρονα (1453–)', value: 'el' },
  { label: 'guarani', value: 'gn' },
  { label: 'ગુજરાતી', value: 'gu' },
  { label: 'Ayisyen, Kreyòl Ayisyen', value: 'ht' },
  { label: 'Hausa', value: 'ha' },
  { label: 'עִברִית', value: 'he' },
  { label: 'नहीं', value: 'hi' },
  { label: 'Magyar', value: 'hu' },
  { label: 'íslenskur', value: 'is' },
  { label: 'Igbo', value: 'ig' },
  { label: 'bahasa Indonesia', value: 'id' },
  { label: 'Gaeilge', value: 'ga' },
  { label: 'Italiano', value: 'it' },
  { label: '日本', value: 'ja' },
  { label: 'basa jawa', value: 'jv' },
  { label: 'ಕನ್ನಡ', value: 'kn' },
  { label: 'қазақ', value: 'kk' },
  { label: 'ខ្មែរកណ្តាល', value: 'km' },
  { label: 'Kinyarwanda', value: 'rw' },
  { label: 'кыргыз, кыргыз', value: 'ky' },
  { label: '한국인', value: 'ko' },
  { label: 'Kurdî', value: 'ku' },
  { label: 'ແຮງ\u200bງານ', value: 'lo' },
  { label: 'Latinus', value: 'la' },
  { label: 'latviski', value: 'lv' },
  { label: 'Lingala', value: 'ln' },
  { label: 'lietuvių', value: 'lt' },
  { label: 'Luxembourgish, Letzeburgesch', value: 'lb' },
  { label: 'македонски', value: 'mk' },
  { label: 'Malagasy', value: 'mg' },
  { label: 'Melayu', value: 'ms' },
  { label: 'മലയാളം', value: 'ml' },
  { label: 'Malti', value: 'mt' },
  { label: 'Maori', value: 'mi' },
  { label: 'मराठी', value: 'mr' },
  { label: 'Монгол', value: 'mn' },
  { label: 'नेपाली', value: 'ne' },
  { label: 'norsk', value: 'no' },
  { label: 'Norwegian Bokmål', value: 'nb' },
  { label: 'ଓଡିଆ', value: 'or' },
  { label: 'Oromo', value: 'om' },
  { label: 'پښتو، پښتو', value: 'ps' },
  { label: 'فارسی', value: 'fa' },
  { label: 'Polski', value: 'pl' },
  { label: 'Português', value: 'pt' },
  { label: 'ਪੰਜਾਬੀ, ਪੰਜਾਬੀ', value: 'pa' },
  { label: 'Runasimi', value: 'qu' },
  { label: 'română, moldovenească, moldovenească', value: 'ro' },
  { label: 'Русский', value: 'ru' },
  { label: 'Samoa', value: 'sm' },
  { label: 'संस्कृत', value: 'sa' },
  { label: 'Српски', value: 'sr' },
  { label: 'Shona', value: 'sn' },
  { label: 'سنڌي', value: 'sd' },
  { label: 'සිංහල', value: 'si' },
  { label: 'slovenský', value: 'sk' },
  { label: 'Slovenščina', value: 'sl' },
  { label: 'Somali', value: 'so' },
  { label: 'Senyesemane sa Boroa', value: 'st' },
  { label: 'Español', value: 'es' },
  { label: 'Sundanese', value: 'su' },
  { label: 'kiswahili', value: 'sw' },
  { label: 'svenska', value: 'sv' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'тоҷикӣ', value: 'tg' },
  { label: 'தமிழ்', value: 'ta' },
  { label: 'Татар', value: 'tt' },
  { label: 'తెలుగు', value: 'te' },
  { label: 'แบบไทย', value: 'th' },
  { label: 'ትግሪኛ', value: 'ti' },
  { label: 'Tsonga', value: 'ts' },
  { label: 'Türkçe', value: 'tr' },
  { label: 'Türkmenler', value: 'tk' },
  { label: 'Twi', value: 'tw' },
  { label: 'ئۇيغۇر ، ئۇيغۇر', value: 'ug' },
  { label: 'українська', value: 'uk' },
  { label: 'اردو', value: 'ur' },
  { label: "o'zbek", value: 'uz' },
  { label: 'Tiếng Việt', value: 'vi' },
  { label: 'Cymraeg', value: 'cy' },
  { label: 'isiXhosa', value: 'xh' },
  { label: 'יידיש', value: 'yi' },
  { label: 'Yoruba', value: 'yo' },
  { label: 'Zulu', value: 'zu' },
];
